import React from 'react';
import './styles.css';

const SiteFooter = () => {
  return (
    <div className="site-footer">
      <span>@ 2020 Serlina Utami. All Rights Reserved.</span>
    </div>
  )
}

export default React.memo(SiteFooter);